import React, { useState } from "react";
import CategoryForm from "./CategoryForm";
import { createCategory } from "../../api/categoryService";
import { getErrorMessage } from "../../utils/errorHandler"

export default function AddCategory() {
  const [loading, setLoading] = useState(false);
  const [backendErrors, setBackendErrors] = useState({})

  const handleAddCategory = async (payload) => {
    try {
      setLoading(true);
      const response = await createCategory(payload);
       if (response?.success === false || response?.status === 422) {
      setBackendErrors(response?.error || {});
      return ; 
    }
     return response;
    } catch (error) {
      console.log("Create Error:", error);
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <CategoryForm
      onSubmit={handleAddCategory}
      loading={loading}
      backendErrors={backendErrors}
      isEdit={false}   
    />
  );
}